import React from 'react';
import { VisuallyHidden } from '../../../VisuallyHidden';
import { Heart } from '@olxbr/ds-icons';
import * as Styles from './styles';
export const FavoriteButton = _ref => {
  let {
    children,
    isFavorited,
    onFavoriteClick
  } = _ref;
  if (!children) return null;
  return React.createElement(Styles.ButtonWrapper, {
    onClick: onFavoriteClick,
    "data-ds-component": "DS-AdCard-Button"
  }, isFavorited ? React.createElement(React.Fragment, null, React.createElement(Styles.FavoriteIcon, {
    color: "var(--color-feedback-error-100)"
  }), React.createElement(VisuallyHidden, null, "Remover dos favoritos")) : React.createElement(React.Fragment, null, React.createElement(Heart, {
    color: "var(--color-neutral-120)"
  }), React.createElement(VisuallyHidden, null, "Adicionar aos favoritos")));
};